import React from 'react';

import { AccountCardItem, AccountCardType } from '../../models/account';
import { CreditCardsListItem } from '../CreditCardsList';
import AccountListElement from './AccountListElement';

interface Props {
    accountCards: AccountCardItem[];
    detailsLink?: string;
}

const AccountCardList: React.FC<Props> = ({ accountCards, detailsLink }) => {
    return (
        <>
            {accountCards.map((accountCardItem) => (
                <React.Fragment key={accountCardItem.accountNumber.value}>
                    {accountCardItem.accountType === AccountCardType.ACCOUNT ? (
                        <AccountListElement account={accountCardItem.account!} detailsLink={detailsLink} hideDecimals />
                    ) : (
                        <CreditCardsListItem card={accountCardItem.card!} />
                    )}
                </React.Fragment>
            ))}
        </>
    );
};

export default AccountCardList;
